module.exports = __webpack_public_path__ + "static/media/icn_kyc_doc_rejected.b49c7a51.svg";